import $ from 'jquery';
import usePopup from '@global/composable/usePopup';

const { popupDialog } = usePopup();

function toggleHeaderClass() {
  const $win = $(window);
  const $body = $('body');
  const StaticHeaderCssClass = 'header_static';
  let scrollTop;
  let topBannerHeight;

  function toggleClass() {
    scrollTop = $win.scrollTop();
    topBannerHeight = $('#topBanner').height();

    if (scrollTop > topBannerHeight) {
      $body.removeClass(StaticHeaderCssClass);
    } else {
      $body.addClass(StaticHeaderCssClass);
    }
  }

  toggleClass();
  $win.scroll(() => {
    toggleClass();
  });
}

function navGlobal() {
  const pathName = global.location.pathname.toLowerCase();

  function currentCate() {
    // cates 以網址字串判，優先條件在前，例如 sports women 不包含 women，women 不包含 men
    const cates = ['PREORDER', 'Article', 'SPORTS', 'WOMEN', 'KIDS', 'MEN'];

    const pathSearch = global.location.search.toLowerCase();

    let pathSearchCate = '';
    if (pathSearch) pathSearchCate = pathSearch.split('menu=')[1] || '';

    // 依序比對 cates
    let cateName;
    for (let i = 0; i < cates.length; i++) {
      cateName = cates[i].toLowerCase();
      if (pathName.indexOf(cateName) > -1 || pathSearchCate.indexOf(cateName) > -1) {
        set(cateName);
        // 已符合條件就跳離for loop，避免重複條件
        break;
      }
    }

    // set
    function set(cateKey) {
      for (let i = 0; i < cates.length; i++) {
        if (cateKey === cates[i].toLowerCase()) {
          $(`.nav li#${cates[i]}`).addClass('active');
          // 已符合條件就跳離for loop，減少運算
          break;
        }
      }
    }
  }

  if (pathName.indexOf('market') === -1 && pathName.indexOf('productpage') === -1) currentCate();
}

function navDesktop() {
  $('#page-shop .product-menu').stick_in_parent(); // 貼頂套件
}

function subnavDesktop() {
  const $el = $('.subnav');

  function hover(target) {
    let isDrag = 0;
    let isEnter = 0;
    let timerOut = 0;

    $el.parent().hover(
      function () {
        const $that = $(this);

        if (!$that.find('.subnav').hasClass('subnav--newsletter')) {
          isEnter = 1;

          if (isDrag === 0) {
            $that.siblings().find('.subnav').removeClass('open');
          }
          clearTimeout(timerOut);
          $that.find('.subnav').addClass('open');
        }
      },
      function () {
        const $that = $(this);

        if (!$that.find('.subnav').hasClass('subnav--newsletter')) {
          isEnter = 0;

          timerOut = setTimeout(() => {
            if (isDrag === 0) {
              $that.find('.subnav').removeClass('open');
            }
          }, 600);
        }
      },
    );

    if (document.addEventListener) {
      document.addEventListener(
        'mousedown',
        (e) => {
          if (e.target.className === 'slider') {
            isDrag = 1;
            $(this).addClass('dragging');
            $(document).one('mouseup', () => {
              if (isEnter === 0) {
                timerOut = setTimeout(() => {
                  $el.removeClass('open');
                }, 1000);
              }
              isDrag = 0;
            });
          }
        },
        true,
      );
    }
  }

  function click() {
    $el
      .parent()
      .find('a')
      .on('click', function () {
        const $that = $(this);

        if ($that.parent().find('.subnav').hasClass('subnav--newsletter')) {
          $that.parent().siblings().find('.subnav').removeClass('open');
          $that.parent().find('.subnav').toggleClass('open');
        }
      });
  }

  function close() {
    $el.on('click', '.subnav__close', function () {
      $(this).parent().removeClass('open');
    });
  }

  hover();
  click();
  close();
}

function navMobile() {
  const $allList = $('.category_list, .member_list, .more_list');

  function resetNav() {
    // secnav 從 header 拉出來做成 tabbar
    $('.header').after($('.secnav'));
  }

  let winScrollTop;

  function toggleNav() {
    const $nav = $('.nav');
    const showClass = 'js-navShow';
    const $categoryList = $('.category_list');
    $nav.on('click', (e) => {
      // 先判分類的子列表是否有展開
      if ($(e.target).hasClass(showClass) && $categoryList.filter(':visible').length > 0) {
        $('.nav a[data-cateid]').removeClass('active');
        $('.wrap').removeClass('disappear');
        $categoryList.hide();
        setTimeout(() => {
          // 非同步
          $(window).scrollTop(winScrollTop);
        });
      }

      // 再判分類列表是否有展開
      if ($(e.target).is('.nav')) {
        $nav.toggleClass(showClass);
      }
    });
  }

  function topLevel() {
    // 第一層開關
    const categoryButton = '.nav a[data-cateid]';
    const memberButton = '.secnav-right__account > a';
    const moreButton = '.secnav-right__more > a';
    const $allListButton = $(categoryButton).add($(memberButton)).add($(moreButton));

    $allListButton.on('click', function (e, target) {
      e.preventDefault();
      let targetDom = target;

      $('.subnav_mobile').removeClass('open'); // 關閉社群列表
      $('body').addClass('js-headerShow'); // 顯示 header

      // 判斷 target
      if ($(e.currentTarget).is(categoryButton)) {
        targetDom = `.category_list[data-cateid=${$(this).data('cateid')}]`;
      } else if ($(e.currentTarget).is(memberButton)) {
        targetDom = '.member_list';
      } else if ($(e.currentTarget).is(moreButton)) {
        targetDom = '.more_list';
      }

      // 如果所有列表都還沒開就記錄卷軸位置
      if ($allList.filter(':visible').length === 0) {
        winScrollTop = $(window).scrollTop();
      }

      // 如果自己沒開表示正要執行打開動作
      if ($(targetDom).filter(':visible').length === 0) {
        $allListButton.removeClass('active');
        $(this).addClass('active');
        $('.recommend, .event-panel').hide();
        $('.wrap').addClass('disappear'); // 避免重新 loading 造成畫面閃爍，使用css控制
        $(targetDom).show();
        $allList.not(targetDom).hide(); // 除了自己以外的都hide吧
        setTimeout(() => {
          // 非同步
          $(window).scrollTop(0);
        });
      } else {
        // 自己已經開了
        $(this).removeClass('active');
        $('.recommend, .event-panel').show();
        $('.wrap').removeClass('disappear');
        $(targetDom).hide();
        setTimeout(() => {
          // 非同步
          $(window).scrollTop(winScrollTop);
        });
      }

      // more跟member可能target為span，需阻止事件冒泡
      e.stopPropagation();
    });
  }

  // 社群由 subnavMobile() 控制

  function subLevel() {
    // 子層開關
    const $allListSubButton = $allList.find('a');
    $allListSubButton.on('click', function (e) {
      // 有子層才會跑
      if ($(this).next('ul').children('li').length > 0) {
        e.preventDefault();
        $(this).next('ul').toggle();
        /* 沒有提示樣式
          $(this).toggleClass('open close')
          */
      }
    });

    // 預設打開第二個
    $('.more_list > li:nth-child(2) > a').click();
  }

  // 登入按鈕顯示
  function tabStatus() {
    $('li.secnav-right__signout').remove();
  }

  if ($('.header').length > 0) {
    resetNav();
    toggleNav();
    topLevel();
    subLevel();
    tabStatus();
  }
}

function subnavMobile() {
  const $el = $('.subnav_mobile');

  $el.siblings('a').on('click', function () {
    $(this).siblings('.subnav_mobile').toggleClass('open');
  });

  $el.find('.clossFollow').on('click', function () {
    $(this).parent('.subnav_mobile').toggleClass('open');
  });
}

function globalSearch(searchbox) {
  const $el = $(searchbox);
  const $form = $el.children('form');
  const $input = $form.find(':text');

  $(searchbox).on('click', (event) => {
    event.stopPropagation();
  });

  $form.find('.global-search__btn').on('click', (event) => {
    event.preventDefault();
    $form.trigger('submit');
  });

  $input.on('keydown', (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  });

  $input.on('keyup', (event) => {
    if (event.keyCode === 13) {
      $form.trigger('submit');
    }
  });

  $form.on('submit', (event) => {
    const text = $input.val();

    $input.blur();

    if (text === '') {
      popupDialog.alert('請輸入文字', '貼心提醒');
      event.preventDefault();
    }
  });
}

function useNavigation() {
  return {
    toggleHeaderClass,
    navGlobal,
    navDesktop,
    subnavDesktop,
    navMobile,
    subnavMobile,
    globalSearch,
  };
}

export default useNavigation;
